// extracted by mini-css-extract-plugin
export var contentSubtitle = "Content-module--contentSubtitle--ced9a";
export var doubleList = "Content-module--doubleList--7ee0c";
export var experienceText = "Content-module--experienceText--c562e";
export var experienceTitle = "Content-module--experienceTitle--4619f";
export var fadeInAnimation = "Content-module--fadeInAnimation--f22be";
export var hiddenMobile = "Content-module--hiddenMobile--0018a";
export var icon = "Content-module--icon--23d8d";
export var link = "Content-module--link--698e9";
export var list = "Content-module--list--db403";
export var listWrapper = "Content-module--listWrapper--af7ce";